export default {
  // Tabs
  systemTemplate: '系統模板',
  myTemplate: '我的模板',
  // 操作
  customCreate: '自定義創建',
  // 空狀態
  emptyMyTemplate: '暫無自定義模板',
  emptyCanvas: '拖拽組件到此處',
  selectComponentTip: '點擊畫布中的組件進行編輯',
  // 編輯器
  componentLibrary: '組件庫',
  propertyPanel: '屬性配置',
  publicConfig: '公共配置',
  langConfig: '當前語言配置',
  templateManager: '模板管理',
  newTemplate: '新建模板',
  cloneTemplate: '複製模板',
  deleteTemplate: '刪除模板',
  templateName: '模板名稱',
  templateType: '模板類型',
  supportedLangs: '支持語言',
  // 頁面配置
  pageConfig: '頁面配置',
  pageTitle: '頁面標題',
  pageTitlePlaceholder: '請輸入頁面標題',
  canvasConfig: '畫布配置',
  bgColor: '背景色',
  padding: '邊距',
  styleConfig: '樣式配置',
  noStyleConfig: '該組件暫無樣式配置',
  // 組件名稱
  component_carousel: '輪播圖',
  component_productInfo: '產品資訊',
  component_antiFake: '防偽資訊',
  component_traceability: '溯源資訊',
  component_imageGrid: '圖片櫥窗',
  component_spacer: '空白條',
  component_activityPopup: '活動彈窗',
  component_videoPlayer: '視頻',
  component_bottomMenu: '底部菜單',
};
